import _ from "lodash";
import moment from "moment";
import { convertToMoment } from "../helpers/date";

const TrafficControl = {};

// Rule
//   {
//     attribute: "checkedCount",
//     operator: ">",
//     value: 3,
//     "skip-to": "page.id|summary|alternateEnding.id"
//   }

TrafficControl.operatorMap = {
  "=": "equal",
  ">": "greaterThan",
  "<": "lessThan",
  contains: "contains"
};

TrafficControl.operators = {
  equal(first, second) {
    if (moment.isMoment(first)) {
      return first.isSame(convertToMoment(second));
    } else {
      return first == second;
    }
  },
  greaterThan(first, second) {
    if (moment.isMoment(first)) {
      return first.isAfter(convertToMoment(second));
    } else if (_.isString(first)) {
      return first.length > second.length;
    } else {
      return first > second;
    }
  },
  lessThan(first, second) {
    if (moment.isMoment(first)) {
      return first.isBefore(convertToMoment(second));
    } else if (_.isString(first)) {
      return first.length < second.length;
    } else {
      return first < second;
    }
  },
  contains(first, second) {
    return first.indexOf(second) != -1;
  }
};

TrafficControl.evalRules = (questionMeta, rules) => {
  let rule = _.find(rules, rule => {
    return TrafficControl.evalRule(questionMeta, rule);
  });
  return rule || null;
};

TrafficControl.evalRule = (questionMeta, rule) => {
  let operator = TrafficControl.operatorMap[rule["operator"]] || "equal";
  let operation = TrafficControl.operators[operator];
  let attributeValue = questionMeta[rule["attribute"]] || "";
  let valueToCompare = rule["value"] || "";
  return operation(attributeValue, valueToCompare);
};

export { TrafficControl };
